import { NgModule } from '@angular/core';

import { SharedModule } from '../../../../../shared';

import { UsuarioEmailAdministrativoSelectComponent } from './usuario-email-administrativo-select.component';

@NgModule({
    imports: [
        SharedModule
    ],
    declarations: [
        UsuarioEmailAdministrativoSelectComponent
    ],
    exports: [
        UsuarioEmailAdministrativoSelectComponent
    ]
})
export class UsuarioEmailAdministrativoSelectModule { }
